/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WindowChangeEnum = 1 | 2;

export const WindowChangeEnum = {
    NUMBER_1: 1 as WindowChangeEnum,
    NUMBER_2: 2 as WindowChangeEnum
};

